import React, {
  useState, useRef, useEffect,
} from 'react'

import {
  classnames, ClosingDropdown, Close, ChevronDown, Icon,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  arrayOf, node, oneOf, string, func, object, bool,
} from 'prop-types'

import { EMPTY_ARRAY, NOOP } from 'Utils/stableDefaults'
import useDelayLoad from 'Utils/useDelayLoad'

import FiltersTags from './Components/FiltersTags'

const chevronDownIcon = (
  <Icon svgComponent={ChevronDown} color="dark" notSpaced className="trail-icon" />
)

function FiltersWrapperWithTags({
  currentlySelectedFiltersObjects = EMPTY_ARRAY,
  placeholder,
  positionHorizontal = 'right',
  type = '',
  content,
  handleFilterChange,
  functionToCleanLabel = null,
  tagClassName = null,
  onOpenChange = null,
  triggerCloseDropdown = false,
  setTriggerCloseDropdown = NOOP,
}) {
  const { isLoaded, elementRef } = useDelayLoad()

  const containerRef = useRef(null)

  const closeIcon = (
    <Icon svgComponent={Close} color="dark" notSpaced className="trail-icon close-icon" onClick={clearAll} />
  )

  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    if (onOpenChange) {
      onOpenChange(isOpen)
    }
  }, [isOpen])

  function clearAll(e) {
    e.stopPropagation()
    e.preventDefault()
    handleFilterChange([], undefined, undefined, true)
  }

  return (
    <ClosingDropdown
      content={isLoaded ? content : null}
      isSimpleContent
      isSpaced
      size="large"
      position={{ horizontal: positionHorizontal }}
      onOpenChange={setIsOpen}
      className={classnames('filters-wrapper-with-tags', type && `filters-wrapper-with-tags__${type}`)}
      triggerCloseDropdown={triggerCloseDropdown}
      setTriggerCloseDropdown={setTriggerCloseDropdown}
      withBackdrop
    >
      <div
        ref={elementRef}
        className={classnames(
          `cgt-text-input cgt-text-input--medium cgt-text-input--primary cgt-text-input--icon-trail
          cgt-input--type-tags filter-tags-input`,
          !currentlySelectedFiltersObjects.length && 'cgt-text-input--grey',
          isOpen && 'cgt-text-input--focused filters-wrapper-with-tags--opened',
        )}
      >
        <div ref={containerRef} className="cgt-tags-input filter-tags-input__inner">
          {currentlySelectedFiltersObjects.length > 0 ? (
            <FiltersTags
              currentlySelectedFiltersObjects={currentlySelectedFiltersObjects}
              handleFilterChange={handleFilterChange}
              functionToCleanLabel={functionToCleanLabel}
              tagClassName={tagClassName}
              containerRef={containerRef}
            />
          ) : (
            <div className="cgt-tags-input__placeholder">
              {placeholder}
            </div>
          )}
        </div>
        {currentlySelectedFiltersObjects.length > 0 ? closeIcon : chevronDownIcon}
      </div>
    </ClosingDropdown>
  )
}

FiltersWrapperWithTags.propTypes = {
  currentlySelectedFiltersObjects: arrayOf(object),
  placeholder: string.isRequired,
  positionHorizontal: oneOf(['left', 'right']),
  type: string,
  content: node.isRequired,
  handleFilterChange: func.isRequired,
  functionToCleanLabel: func,
  tagClassName: string,
  onOpenChange: func,
  triggerCloseDropdown: bool,
  setTriggerCloseDropdown: func,
}

export default FiltersWrapperWithTags
